import { render, staticRenderFns } from "./ShopPage.vue?vue&type=template&id=114ae73a&scoped=true"
import script from "./ShopPage.vue?vue&type=script&lang=js"
export * from "./ShopPage.vue?vue&type=script&lang=js"
import style0 from "./ShopPage.vue?vue&type=style&index=0&id=114ae73a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114ae73a",
  null
  
)

export default component.exports